// extracted by mini-css-extract-plugin
export default {"issueFieldTokenWrapper":"IssueFieldEvent-module__issueFieldTokenWrapper--fgvyd","issueFieldValueLink":"IssueFieldEvent-module__issueFieldValueLink--Aiu3E"};